import React from 'react';

type ItemType = {
  id: string;
  text: string;
  icon?: string;
};

type ItemProps = {
  data: ItemType;
  active?: boolean;
  onClick?: () => void;
};

function Item({data: {id, text, icon}, active, onClick}: ItemProps) {
  return (
    <div
      key={id}
      className={`flex items-center p-1 ${
        active ? 'bg-white rounded-large' : ''
      }`}
      onClick={onClick}
    >
      {icon && <img src={icon} alt={text} />}
      {text}
    </div>
  );
}

export default Item;
